import { cusAxios, PREFIX } from './main';

const getCollection = async () => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/gamekit/collection_list`
  });
  return response;
};

const getCasinoList = async () => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/gamekit/casino_list`
  });
  return response;
};

const addNewCollection = async ({ name, casinoList, currencyList, mergeProvider }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/gamekit/collection_append`,
    data: { name, casinoList, currencyList, mergeProvider }
  });
  return response;
};

const updateCollection = async ({
  collectionId,
  name,
  currencyList,
  casinoList,
  mergeProvider
}) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/gamekit/collection_update`,
    data: { collectionId, name, casinoList, currencyList, mergeProvider }
  });
  return response;
};

const deleteCollection = async ({ collectionId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/gamekit/collection_delete`,
    data: { collectionId }
  });
  return response;
};

const collectionInfo = async ({ collectionId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/gamekit/collection_info`,
    data: { collectionId }
  });
  return response;
};

const getCategoryCollection = async ({ collectionId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/gamekit/category_list`,
    data: { collectionId }
  });
  return response;
};

const addCategoryCollection = async ({
  collectionId,
  displayOnMain,
  priority,
  enabled,
  groupGameType,
  bonusWager,
  nameList
}) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/gamekit/category_append`,
    data: { collectionId, priority, displayOnMain, enabled, nameList, bonusWager, groupGameType }
  });
  return response;
};

const updateCategoryCollection = async ({
  categoryId,
  priority,
  enabled,
  displayOnMain,
  groupGameType,
  bonusWager,
  nameList
}) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/gamekit/category_update`,
    data: { categoryId, priority, displayOnMain, enabled, nameList, bonusWager, groupGameType }
  });
  return response;
};

const deleteCategoriesCollection = async ({ categoryList }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/gamekit/category_delete`,
    data: { categoryList }
  });
  return response;
};

const categoryGamesCollection = async ({ categoryId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/gamekit/category_games`,
    data: { categoryId }
  });
  return response;
};

const categoryGameSaveCollection = async (data) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/gamekit/category_game_save`,
    data: data
  });
  return response;
};

const getCategoriesGame = async ({ collectionId, source, uuid }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/gamekit/game_category_list`,
    data: { collectionId, source, uuid }
  });
  return response;
};

const changeCategoriesGame = async ({ collectionId, source, uuid, include, exclude }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/gamekit/game_category_set`,
    data: { collectionId, source, uuid, include, exclude }
  });
  return response;
};

const getSourceList = async () => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/gamekit/source_list`
  });
  return response;
};

const getSourceGames = async ({ sourceId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/gamekit/source_games`,
    data: { sourceId }
  });
  return response;
};

const gameSourceInclude = async ({ sourceId, categoryId, gameList, priority }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/gamekit/source_game_include`,
    data: { sourceId, categoryId, gameList, priority }
  });
  return response;
};

export const API_GAMEKIT = {
  collection: {
    list: getCollection,
    add: addNewCollection,
    update: updateCollection,
    delete: deleteCollection,
    info: collectionInfo,
    casinos: getCasinoList,
    source: {
      list: getSourceList,
      games: getSourceGames
    },
    categories: {
      list: getCategoryCollection,
      add: addCategoryCollection,
      update: updateCategoryCollection,
      delete: deleteCategoriesCollection,
      includesGames: gameSourceInclude,
      games: {
        list: categoryGamesCollection,
        save: categoryGameSaveCollection,
        categories: getCategoriesGame,
        changeCategory: changeCategoriesGame
      }
    }
  }
};
